"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'project.form.title.edit': 'Edytuj projekt',
    'project.form.title.add': 'Dodaj projekt',
    'project.form.back': 'Wstecz',
    'project.form.color.placeholder': '#007bff',
    'project.form.icon.placeholder': 'Wybierz ikonę projektu',
};
